// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  civId: __t.u64().primaryKey().name("civ_id"),
  name: __t.string(),
  banner: __t.string(),
  founderCityId: __t.u64().name("founder_city_id"),
  status: __t.string(),
  treasury: __t.i64(),
  titheBps: __t.u16().name("tithe_bps"),
  proposedAt: __t.timestamp().name("proposed_at"),
  formedAt: __t.timestamp().name("formed_at"),
});
